import React from 'react';
import {Tabs} from 'antd';
import {useParams, useSearchParams} from 'react-router-dom';
import SatQuestionsTable from "./SatQuestionsTable";

const SatQuestions = () => {
    const {collection_id} = useParams();

    const [searchParams, setSearchParams] = useSearchParams();
    const activeKey = searchParams.get('tab') || "1";

    const onChangeTab = key => {
        setSearchParams({ tab: key });
    };

    const items = [{
        key: '1',
        label: <h3>English part 1</h3>,
        children: <SatQuestionsTable collection_id={collection_id} step="1"/>,
    }, {
        key: '2',
        label: <h3>English part 2</h3>,
        children: <SatQuestionsTable collection_id={collection_id} step="2"/>,
    }, {
        key: '3',
        label: <h3>Math part 1</h3>,
        children: <SatQuestionsTable collection_id={collection_id} step="3"/>,
    }, {
        key: '4',
        label: <h3>Math part 2</h3>,
        children: <SatQuestionsTable collection_id={collection_id} step="4"/>,
    }];


    return (<div>
        <Tabs
            activeKey={activeKey}
            defaultActiveKey="1"
            items={items}
            onChange={onChangeTab}
        />

    </div>);
};

export default SatQuestions;
